import { ApiUrl } from '@common/enums';
import { DiagonalCornerModel } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const diagonalCornersService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchDiagonalCorners: builder.query<DiagonalCornerModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.DIAGONAL_CORNERS,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchDiagonalCornersQuery, useLazyFetchDiagonalCornersQuery } = diagonalCornersService;
